<template>
  <div class="spaceCenter">
    <div class="exchange-card" v-loading="loading">
      <div class="exchange-tab-box">
        <el-tabs v-model="activeName" @tab-click="changeTab">
          <el-tab-pane name="Deposit">
            <span slot="label"><i class="iconfont trn-deposits"></i> Deposit</span>
          </el-tab-pane>
          <el-tab-pane name="Withdraw">
            <span slot="label"><i class="iconfont trn-withdraw"></i> Withdraw</span>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="exchange-tab-body">
        <div class="deposite-balance">
          Deposits:
          <span class="deposite-balance-num"><big-number :number.sync="depositeBalance" /></span>
          <span class="word-sm">TCash</span>
        </div>
        <div class="spaceBetween">
          <span class="word-sm">
            <img src="@/assets/image/exchange/jiantou2.svg" style="width:0.16rem;" />
            1 TCash = $ {{ price }}
          </span>
          <span class="word-sm" style="color: rgb(220, 224, 231);">
            Balance : <big-number :number.sync="balance" />
          </span>
        </div>
        <div class="spaceBetween exchange-item">
          <div class="spaceLeft">
            <img src="@/assets/image/exchange/ustn.png" style="width:0.44rem;margin-right:0.16rem;" />
            <div>
              <div class="word-sm-black">TCash</div>
              <span class="word-sm" style="color:rgb(86, 98, 122)">Deposit</span>
            </div>
          </div>
          <div>
            <el-input class="exchange-input" placeholder="0.00" v-model="exchangeNum" @change="exchangeInput" />
            <div class="text-right word-sm-num">$ {{ changeMoney }}</div>
          </div>
        </div>
        <div class="word-sm" style="margin-top:0.88rem;line-height:0.32rem;margin-bottom:0.2rem;">
          Deposit rules :<br />
          1. The deposit amount must be greater than or equal to 10^-9 TCash<br />
          2. Deposit interest will be calculated from the second day of deposit
        </div>
        <checkLoginBtn @clickHandle="submit" />
      </div>
    </div>
  </div>
</template>

<script>
import checkLoginBtn from "@/components/CheckLoginBtn/index.vue";
import { toBigNum, toBigItem } from "@/utils/bigNumberTran.js";
import { isIntNum } from "@/utils/index.js"
import BigNumber from "bignumber.js";
export default {
  components: { checkLoginBtn },
  data() {
    return {
      loading: false,
      activeName: "Deposit",
      balance: 0,
      price: 0,
      exchangeNum: undefined,
      depositeBalance: 0,
      contractUSTNFinance: {},
      contractUSTN: {},
      contractUnitPrice: {}
    };
  },
  computed: {
    account() {
      return this.$store.getters.metaMaskObj.account;
    },
    changeMoney() {
      return (this.price * (+this.exchangeNum || 0)).toFixed(2);
    }
  },
  methods: {
    async init() {
      try {
        this.loading = true;
        this.exchangeNum = undefined;

        this.contractUSTNFinance = this.$store.getters.contractMap["contractUSTNFinance"].contract;
        this.contractUSTNFinanceAddress = this.$store.getters.contractMap["contractUSTNFinance"].address;

        this.contractUSTN = this.$store.getters.contractMap["contractUSTN"].contract;
        this.contractUSTNAddress = this.$store.getters.contractMap["contractUSTN"].address;
        this.contractUnitPrice = this.$store.getters.contractMap["contractUnitPrice"].contract;
        this.contractUnitPriceAddress = this.$store.getters.contractMap["contractUnitPrice"].address;

        this.getBalance();
        this.getPrice();
        this.queryDepositBalance();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async queryDepositBalance() {
      try {
        this.depositeBalance = await this.contractUSTNFinance.methods["queryDepositBalance"]().call({
          from: this.account
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getBalance() {
      try {
        this.balance = await this.contractUSTN.methods["balanceOf"](this.account).call({
          from: this.account
        });
      } catch (e) {
        console.log("getBalance--", e);
      }
    },
    async getPrice() {
      try {
        let price = await this.contractUnitPrice.methods["getCurrencyValue"](
          this.USTNVal
        ).call({
          from: this.account
        });
        this.price = new BigNumber(price).div(new BigNumber(10000)).toNumber();
      } catch (e) {
        console.log(e);
      }
    },
    changeTab() {
      this.exchangeNum = undefined;
    },
    exchangeInput() {
      if (!isIntNum(+this.exchangeNum)) {
        this.$message.warning(`Please enter a number`);
        return;
      }
      if (this.exchangeNum <= 0 || !this.exchangeNum) {
        this.$message.warning("Please enter a value greater than 0");
        this.exchangeNum = undefined;
        return;
      }
      if (this.activeName == 'Deposit') {
        if (new this.BigNumber(this.exchangeNum).comparedTo(new this.BigNumber(0.000000001)) < 0) {
          this.$message.warning("The deposit amount must be greater than or equal to 10^-9 TCash");
          return;
        }
        if (toBigItem(this.exchangeNum).comparedTo(this.balance) > 0) {
          this.$message.warning("Insufficient TCash balance");
          return;
        }
      }
      if (this.activeName == 'Withdraw' && toBigItem(this.exchangeNum).comparedTo(this.depositeBalance) > 0) {
        this.$message.warning("Insufficient deposite balance");
        return;
      }
      return true;
    },
    submit(btn) {
      if (!this.exchangeInput()) {
        btn.closeLoad();
        return;
      }

      let methodName = this.activeName == 'Deposit' ? "deposit" : "withdrawal";
      const tx_builder = this.contractUSTNFinance.methods[methodName](toBigNum(this.exchangeNum));
      const encoded_tx = tx_builder.encodeABI();

      web3.eth.sendTransaction({
        gas: this.$store.getters.gas,
        from: this.account,
        to: this.contractUSTNFinanceAddress,
        value: 0,
        data: encoded_tx,
      }).then(res => {
        this.$message.success("You have successfully " + (this.activeName == 'Deposit' ? "deposited TCash!" : "withdrawal!"));
        btn.closeLoad();
        this.init();
        this.refresh();
      })
        .catch((error) => {
          this.$message.error("operation failed");
          console.error(error);
          btn.closeLoad();
        });
    },
    refresh() {
      this.$emit("refresh")
    }
  },
  created() {
    if (this.$route.query.withdraw == 1) {
      this.activeName = "Withdraw";
    }
    this.init();
  },
  mounted() { }
};
</script>
<style scoped lang="scss">
.exchange-card {
  padding: 0.2rem 0 0.8rem 0;
  border-radius: 0.24rem;
  background: linear-gradient(90deg, #020202 0%, #020202 42%, #00266B 100%);
  border: 0.01rem solid #272D38;
  min-width: 7.26rem;

  .exchange-tab-box {
    border-bottom: 0.02rem solid rgba(146, 157, 173, 0.2);
    padding: 0 0.4rem;
  }

  .exchange-tab-body {
    padding: 0.38rem 0.4rem 0 0.4rem;
  }

  ::v-deep  .el-tabs {
    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__nav {
      width: 100%;

      .el-tabs__item {
        font-size: 0.24rem;
        color: #929dad;
        padding: 0.28rem 0.65rem;
        height: auto;
        width: 50%;
        text-align: center;

        &.is-active {
          color: #FFFFFF;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;

          i {
            color: #225BFC;
          }
        }
      }
    }

    .el-tabs__active-bar {
      background: #225BFC;
    }

    .el-tabs__nav-wrap::after {
      height: 0;
    }
  }

  .exchange-item {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 0.08rem;
    border: 1px solid rgba(255, 255, 255, 0.25);
    padding: 0.24rem 0.2rem;
    min-width: 5.6rem;
    margin-bottom: 0.16rem;
  }

  .exchange-jiantou {
    width: 0.56rem;
    position: absolute;
    left: 50%;
    margin-left: -0.28rem;
    margin-top: -0.34rem;
  }

  .exchange-input {
    ::v-deep  .el-input__inner {
      border: none;
      text-align: right;
      font-size: 0.36rem;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: #FFFFFF;
      padding: 0 0;
      background: transparent;
    }
  }

  .word-sm {
    font-size: 0.18rem;
    // font-weight: 500;
    color: #aaaaaa;
    line-height: 0.2rem;
    // margin-bottom: 0.13rem;
  }

  .word-big-num {
    font-size: 0.36rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 0.42rem;
  }

  .word-sm-black {
    font-size: 0.2rem;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.24rem;
  }

  .word-sm-num {
    color: #929DAD;
    font-size: 0.2rem;
    line-height: 0.24rem;
  }

  .common-btn-blue {
    margin-top: 0.2rem;
  }

  .iconfont {
    font-size: 0.22rem !important;
    margin-right: 0.03rem;
  }

  .deposite-balance {
    font-size: .2rem;
    font-weight: 600;
    text-align: center;
    margin-bottom: .4rem;
    color: rgba(255, 255, 255, .7);

    .deposite-balance-num {
      .big-number {
        color: #fff;
        font-weight: 600;
        font-size: .28rem;
      }
    }
  }

  .spaceBetween {
    margin-bottom: .13rem;
  }
}
</style>
